import {
  getAnalyticsUrl,
  sanitizeTextForAnalytics,
  pdpTypeFormat,
  calculateCartData,
} from "@/utils/helper"
import { store } from "@/store"

export const callOverlayEventInfoAnalytics = async (
  pdpUrl = "",
  productEventInfo = "",
  productInfo = {},
  data = {}
) => {
  const overlayEventInfo = {
    clickInternalLinks: "true",
    eventAction: "cart overlay:product navigation",
    eventMsg: "n/a",
    eventName: "cart overlay:product navigation",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: sanitizeTextForAnalytics(data.name),
    internalLinkPosition: "cart overlay",
    internalLinkType: "cart overlay:navigation",
    internalLinkURL: getAnalyticsUrl(pdpUrl),
    internalLinkZoneName: "cart:overlay",
  }
  if (window.adobeDataLayer || productEventInfo) {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const cartObj = store?.getState()?.cart?.cart
    if (cartObj) {
      const { cart } = await calculateCartData({ cart: cartObj }, true)
      page.cart = cart
    }
    const eventInfo = productEventInfo
      ? JSON.parse(productEventInfo)
      : overlayEventInfo
    eventInfo.internalLinkURL = getAnalyticsUrl(pdpUrl)
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      productInfo,
      page,
    })
  }
}

export const getCustomAnalyticsData = (
  cartAnalytics = {},
  cartID = "",
  subtotal = ""
) => {
  const { item } = cartAnalytics
  return JSON.stringify({
    cart: { cartID: cartID, price: subtotal, items: item },
  })
}

export const getProductInfoAnalytics = (data, needsRemovedQuantity = false) => {
  const { getState = () => {} } = window.adobeDataLayer
  const page = getState().page

  const customerFacingSKUId = data.customerFacingSKU || data.sku

  return {
    productBrand: page?.site?.siteName,
    description: sanitizeTextForAnalytics(data.desc) || "n/a",
    frequency: "n/a",
    globalPromotionPrice: Number(data.discountPrice)
      ? Number(data.discountPrice)
      : Number(data.unitPrice),
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    priceState:
      data.discountPercent > 0 || data.discountAmount > 0
        ? "percentOff|" + data.discountPercent
        : "regular price",
    productBasePrice: Number(data.unitPrice) || "n/a",
    productCategory: sanitizeTextForAnalytics(data.category) || "n/a",
    productColor: sanitizeTextForAnalytics(data.color) || "n/a",
    productCoupondiscount: "n/a",
    productID: customerFacingSKUId || "n/a",
    productName: sanitizeTextForAnalytics(data.name) || "n/a",
    productPartnerBuyNow: false,
    productRoom: sanitizeTextForAnalytics(data.category) || "n/a",
    productSalePrice: Number(data.discountPrice)
      ? Number(data.discountPrice)
      : Number(data.unitPrice),
    productSaleable:
      page?.productInfo?.pdpType === "bundle" || data?.isBundleParent
        ? "true"
        : Number(data.productSaleable) ?? "true",
    productStatus: data.availableQty >= 0 ? "in stock" : "out of stock",
    productSuperSku: data.superSku ? true : false,
    productTileName: sanitizeTextForAnalytics(data.name) || "n/a",
    quantity: needsRemovedQuantity ? 0 : data.quantity,
    initialQuantity: data.quantity,
    defaultImageName: data.image || "n/a",
    ratings: "n/a",
    numberOfReviews: "n/a",
    pdpType:
      page?.productInfo?.pdpType === "bundle" || data?.isBundleParent
        ? "bundle"
        : pdpTypeFormat({
            businessUnitName: data.businessUnitName,
            ProductIsRetail: data.ProductIsRetail,
            discontinuedProductb: data.discontinuedProductb,
            ProductRequiredAccessoriesGroupsList:
              data.ProductRequiredAccessoriesGroupsList,
            superSku: data.superSku,
          }),
    productFindingMethod: "n/a",
    productCollectionsName:
      sanitizeTextForAnalytics(data.productCollectionsName || data.category) ||
      "n/a",
  }
}

export const previewCartUpdateAnalytics = data => {
  if (window.adobeDataLayer) {
    // here we need to wait for callback of API to add analytics
    // meanwhile we create productInfo and eventInfo objects and just add initialQuantity flag
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const eventInfoData = {
      eventAction: `cart preview:cart update:subtract`,
      eventName: "cart preview:cart update:subtract",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "cart update",
      internalLinkPosition: `cart${data.isBundleParent ? ":bundle" : ""}`,
      internalLinkType: "cart:removal",
      internalLinkZoneName: "cart:preview",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }

    const productInfo = getProductInfoAnalytics(data, true)
    const eventInfo = eventInfoData
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      productInfo,
      page,
    })
  }
}

export const getEventInfo = action => {
  return JSON.stringify({
    eventAction: "cart preview:" + action,
    eventName: "cart preview:" + action,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: action,
    internalLinkPosition: "cart preview",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:preview",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
